import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCustomApiCall, getNewAudienceFilter } from "api/AudienceApi";

export const audienceGetNewFilterData = createAsyncThunk(
  "audience/audienceGetNewFilterData",
  async (data, thunkAPI) => {
    const res = await getNewAudienceFilter();
    return res.data;
  }
);
export const audienceGetCustomApiCall = createAsyncThunk(
  "audience/audienceGetCustomApiCall",
  async ({ url, type, id }, thunkAPI) => {
    if(url.includes(":"))
      return { res: null, type, id };

    const res = await getCustomApiCall(url);
    return { res: res.data, type, id };
  }
);

const audienceSlice = createSlice({
  name: "audienceSetter",
  initialState: {
    audienceName: "",
    audienceDescription: "",
    audienceType: "",
    audienceLoading: true,
    editingAudience :false,
    audienceFilters: [
      {
        customParam:[],
        customParamValue:null,
        customParamId:null,
        filterCategory: [],
        filterPropertiesDropDown: [],
        filterParametersDropDown: [],
        filterValuesDropDown: [],
        filterPropertySelectedIndex: 0,
        filterActionSelectedIndex: 0,
        filterActionId: null,
        filterPropertyId: null,
        filterValueInputType: "",
        filterValueTypeId: null,
        filterValue: null,
        filterValueField: {
          filterValueFieldToShow: "",
          filterValueFieldToSave: "",
        },
        filterParameters: [
          {
            filterPropertyParameterId: "",
            value: "",
            properties: [],
          },
        ],
        filterPatameterToShow: false,
        logicalOperator: "OR",
      },
    ],
  },
  reducers: {
    setAudienceName: (state, action) => {
      state.audienceName = action.payload;
    },
    setAudienceDescription: (state, action) => {
      state.audienceDescription = action.payload;
    },
    setAudienceType: (state, action) => {
      state.audienceType = action.payload;
    },
    setAudienceLoading: (state, action) => {
      state.audienceLoading = action.payload;
    },
    setEditAudience: (state, action) => {
      state.editingAudience = action.payload;
    },
    addAudienceFilters: (state, action) => {
      let audiencefilters = [...state.audienceFilters];
      audiencefilters.push(action.payload);
      state.audienceFilters = audiencefilters;
    },
    setAudienceFilters : (state, action) => {
      state.audienceFilters = action.payload;
    },
    removeAudienceFilters: (state, action) => {
      let audiencefilters = [...state.audienceFilters];
      audiencefilters.splice(action.payload, 1);
      state.audienceFilters = audiencefilters;
    },

    updateCustomParam: (state, action) => {
      console.log("dddddeeeee",state.audienceFilters[action.payload.id])
    state.audienceFilters[action.payload.id].customParam = action.payload.data;
    },

    setCustomParamValue: (state, action) => {
      console.log("uiiiiiiiiiii",action.payload.value)
    state.audienceFilters[action.payload.id].customParamValue = action.payload.value;
    },

    setCustomParamId: (state, action) => {
      console.log("dddddeeeee",state.audienceFilters[action.payload.id])
    state.audienceFilters[action.payload.id].customParmId = action.payload.data;
    },

    
    updateAudienceFilter: (state, action) => {

      switch (action.payload.type) {
        case "filterProperty": {
          state.audienceFilters[action.payload.id].filterPropertyId =
            action.payload.filterPropertyId;
          break;
        }
        case "filterPropertySelectedIndex": {
          state.audienceFilters[action.payload.id].filterPropertySelectedIndex =
            action.payload.filterPropertySelectedIndex - 1;
          break;
        }
        case "filterAction": {
          state.audienceFilters[action.payload.id].filterActionId =
            action.payload.filterActionId;
          break;
        }
        case "filterValuesDropDown": {
          state.audienceFilters[action.payload.id].filterValuesDropDown =
            action.payload.data;
          break;
        }
        case "filterValueTypeId": {
          state.audienceFilters[action.payload.id].filterValueTypeId =
            action.payload.filterValueTypeId;
          break;
        }
        case "filterValue": {
          state.audienceFilters[action.payload.id].filterValue =
            action.payload.filterValue;
          break;
        }
        case "filterValueInputType": {
          state.audienceFilters[action.payload.id].filterValue = null;
          state.audienceFilters[action.payload.id].filterValueInputType =
            action.payload.filterValueInputType;
          break;
        }
        case "filterValueField": {
          state.audienceFilters[
            action.payload.id
          ].filterValueField.filterValueFieldToShow =
            action.payload.data.filterValueFieldToShow;
          state.audienceFilters[
            action.payload.id
          ].filterValueField.filterValueFieldToSave =
            action.payload.data.filterValueFieldToSave;
          break;
        }
        case "filterParameter": {
          state.audienceFilters[action.payload.id].filterParameters[
            action.payload.filterParameterIndex
          ].value = action.payload.filterParameter;
          state.audienceFilters[action.payload.id].filterParameters[
            action.payload.filterParameterIndex
          ].filterPropertyParameterId =
            action.payload.filterPropertyParameterId;
          break;
        }
        case "filterParametersProperties": {
          if( state.audienceFilters[action.payload.id].filterParameters[
            action.payload.filterParameterIndex
          ]){
                    state.audienceFilters[action.payload.id].filterParameters[
            action.payload.filterParameterIndex
          ].properties = action.payload.data;  
          }

          break;
        }
        case "filterPatameterToShow": {

          state.audienceFilters[action.payload.id].filterPatameterToShow =
            action.payload.filterPatameterToShow;
          break;
        }
        case "logicalOperator": {
          state.audienceFilters.map((filter) => {
            filter.logicalOperator = action.payload.logicalOperator;
          });
          break;
        }
        default: {
          return;
        }
      }
    },
    resetAudieceFilters: (state, action) => {
      state.audienceName = "";
      state.audienceDescription = "";
      state.audienceType = "";
      state.audienceLoading = false;
      state.editingAudience= false;

      state.audienceFilters = [
        {
                  customParam:[],

          filterPropertySelectedIndex: 0,
          filterActionSelectedIndex: 0,
          filterActionId: null,
          filterPropertyId: null,
          filterValueInputType: "",
          filterValueTypeId: null,
          filterValue: null,
          filterValueField: {
            filterValueFieldToShow: "",
            filterValueFieldToSave: "",
          },
          filterParameters: [
            {
              filterPropertyParameterId: "",
              value: "",
              properties: [],
            },
          ],
          filterPatameterToShow: false,
          logicalOperator: "OR",
        },
      ];

      console.log("state.audienceFilters",    state.audienceName);
    },
  },

  extraReducers: {
    [audienceGetNewFilterData.fulfilled]: (state, action) => {
      var value_arr = [];
      var category_arr = [];
      var index = 0;
      action.payload &&
        Object.keys(action.payload).forEach((key) => {
          category_arr.push(key);
          action.payload[key].filterProperties.map((val) => {
            val.index = index;
            value_arr.push(val);
            index++;
          });
        });
      state.audienceFilters[0].filterCategory = category_arr;
      state.audienceFilters[0].filterPropertiesDropDown = value_arr || [];
    },
    [audienceGetCustomApiCall.fulfilled]: (state, action) => {

      switch (action.payload.type) {
        case "filterValuesDropDown": {
          state.audienceFilters[action.payload.id].filterValuesDropDown =
            action.payload.res || [];
          break;
        }
        case "filterParametersDropDown": {
          state.audienceFilters[action.payload.id].filterParametersDropDown =
            action.payload.res || [];
          break;
        }
        default: {
          return;
        }
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setAudienceName,
  setEditAudience,
  setAudienceType,
  setAudienceDescription,
  setAudienceLoading,
  addAudienceFilters,
  setAudienceFilters,
  removeAudienceFilters,
  updateAudienceFilter,
  resetAudieceFilters,
  updateCustomParam,
  setCustomParamValue,
  setCustomParamId
} = audienceSlice.actions;

export default audienceSlice.reducer;
